import { Injectable } from '@angular/core';

/**
 * Ensures only one answer hover preview (entity or details) is open across View Data cells.
 */
@Injectable({ providedIn: 'root' })
export class AnswerPreviewHostService {
  private activeOwner: object | null = null;
  private activeClose: (() => void) | null = null;

  /** Close any preview owned by another cell before opening a new one. */
  claim(owner: object, close: () => void): void {
    if (this.activeOwner && this.activeOwner !== owner) {
      this.activeClose?.();
    }
    this.activeOwner = owner;
    this.activeClose = close;
  }

  /** Clear registry when this owner closes its preview. */
  release(owner: object): void {
    if (this.activeOwner === owner) {
      this.activeOwner = null;
      this.activeClose = null;
    }
  }
}
